module.exports = __webpack_public_path__ + "static/media/david-ganey.f17f553a.png";